import React from 'react';
import { StyleProvider, ThemePicker } from 'vcc-ui';

export default function FelaWrapper({ renderer, children, currentTheme }) {
  return (
    <StyleProvider renderer={renderer}>
      <ThemePicker variant={currentTheme}>{children}</ThemePicker>
    </StyleProvider>
  );
}
